"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * @description When director approves a knock, presenter can update
 * both their title and title in AV modal before they join the meeting.
 * Setting updated attendee details to display in presenter banner
 * @param {string} attendeeId
 * @param {string} title
 * @param {string} description
 * @param {string} presenterPhoto
 * @param role
 */

function setAttendeeDetails(attendeeId, title, description, presenterPhoto) {
  var role = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  return (0, _actionUtils.actionCreator)(_types.SET_ATTENDEE_DETAILS, {
    attendeeId: attendeeId,
    title: title,
    description: description,
    presenterPhoto: presenterPhoto,
    role: role
  });
}
var _default = exports["default"] = setAttendeeDetails;